module.exports = __webpack_public_path__ + "img/KTP-202.069457bc.jpg";